<div class="container-box p-3">
  <app-loading-section *ngIf="isLoading && !licenses"></app-loading-section>
  <app-bdc-licenses-form #licenseForm [licenses]="licenses" *ngIf="isLicenseRequired"></app-bdc-licenses-form>
  <app-empty-table *ngIf="!isLicenseRequired">
    <img class="empty-image" src="assets/images/empty_icons/bdc-license.svg" />
    <h5 class="empty-header" i18n>No License Required</h5>
    <p i18n>This unit doesn’t require a license based on current regulations. You’re all set—no action needed.</p>
  </app-empty-table>
</div>
